export default __webpack_public_path__ + "static/media/crown.af203c06.svg";